import HighlightMatch from "../../../utilities/HighlightMatch"

export default function VCIDealerRowDetails({ dealer, searchTerm }) {
  const cityState = dealer.attributes['city-state']
  const auditUnitCount = dealer.attributes['audit-unit-count']

  if (dealer.attributes['is-suspended']) {
    return (
      <div className="flex items-center gap-1 text-sm">
        <div className="min-w-0">
          <HighlightMatch
            str={`${cityState} |`}
            match={searchTerm}
            truncate={true}
          />
        </div>
        <span className="shrink-0 text-yellow">Suspended</span>
      </div>
    )
  }

  return (
    <div className="flex items-center gap-2 text-sm">
      <HighlightMatch
        str={`${cityState} | ${auditUnitCount} ${auditUnitCount === 1 ? 'unit' : 'units'}`}
        match={searchTerm}
        truncate={true}
      />
    </div>
  )
}
